import { render } from "./TradesTable.vue?vue&type=template&id=60e0fa7e&scoped=true"
import script from "./TradesTable.vue?vue&type=script&lang=js"
export * from "./TradesTable.vue?vue&type=script&lang=js"

import "./TradesTable.vue?vue&type=style&index=0&id=60e0fa7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e0fa7e"]])

export default __exports__